import { MAP_NAMES } from 'common/constants';

export const checkIsGoogleMap = (mapName: string) => (
  mapName === MAP_NAMES.google
);
